import { useParams } from "@tanstack/react-router";
import { ReviewFormBuilder } from "@/components/reviews/ReviewFormBuilder";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";
import { useReviewTemplate } from "@/hooks/use-review-templates";

/** One review form, and everything it asks. See `ReviewFormBuilder`. */
export function ReviewFormDetailPage() {
  const { templateId } = useParams({ from: "/dashboard/reviews/forms/$templateId" });
  const { data } = useReviewTemplate(templateId);

  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: "Review Forms", to: "/dashboard/reviews/forms" },
    { label: data?.name ?? "Form" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title={data?.name ?? "Review form"}
        description={data?.description ?? "What this review asks, and who is asked."}
      />
      <ReviewFormBuilder templateId={templateId} />
    </div>
  );
}
